// Section 18: Schooling policy. None / Voluntary / Compulsory 6 to 12 / Compulsory 6 to 14; needs
// a school and a teacher (Section 11). Compulsory options keep children of that age out of work
// while a school stands (shared/eligibility.ts, `schooling` block).
// Default: config.policies.defaults.schooling. Constants: config.skills.
import type { Config } from '../../config';
import { noChangeCost } from '../../core/content-helpers';
import { hasBuilding, isChild, peopleSorted } from '../../core/queries';
import { definePolicy, noModifiers } from '../../core/registry';

export function schooling(config: Config) {
  const s = config.skills;
  const years = config.people.seasonsPerYear;

  return definePolicy({
    id: 'schooling',
    label: 'Schooling',
    section: 'S18',
    group: 'education',
    options: ['none', 'voluntary', 'compulsory-12', 'compulsory-14'],
    default: config.policies.defaults.schooling,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, option) {
      const people = peopleSorted(ctx.state);
      const schoolAge = people.filter(
        (p) => isChild(config, p) && p.ageSeasons >= s.schoolAgeFromYears * years,
      );
      if (option === 'none')
        return [{ key: 'policy.schooling.none', params: { children: schoolAge.length } }];
      const to = s.compulsoryToYears[option];
      const pulled =
        to === null
          ? 0
          : schoolAge.filter((p) => p.job !== 'rest' && p.ageSeasons < (to + 1) * years).length;
      return [
        { key: 'policy.schooling.children', params: { children: schoolAge.length } },
        ...(pulled > 0 ? [{ key: 'policy.schooling.pulled', params: { children: pulled } }] : []),
      ];
    },
    validate(ctx, option) {
      if (s.compulsoryToYears[option] === null || hasBuilding(ctx.state, 'school')) return null;
      return {
        path: 'policies.schooling',
        code: 'policy_locked',
        message: 'Compulsory schooling needs a school.',
      };
    },
  });
}
